import React, { Component } from "react"
import { Field, reduxForm } from "redux-form"
import { connect } from "react-redux"
import * as actions from "../../actions/event"
import { DateTimePicker, DropdownList } from "react-widgets"
import Moment from "moment"
import momentLocalizer from "react-widgets/lib/localizers/moment"
momentLocalizer(Moment)
import fetch from "isomorphic-fetch"
import { Editor, EditorState, RichUtils } from "draft-js"

let tmpVenueList

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div
    className={`form-group ${touched && error ? "has-danger" : touched && warning ? "has-warning" : ""}`}
  >
    <label className="form-control-label">{label}</label>
    <input
      {...input}
      placeholder={label}
      type={type}
      className={`form-control ${touched && error ? "form-control-danger" : touched && warning ? "form-control-warning" : ""}`}
    />
    {touched &&
      ((error && <div className="form-text text-muted">{error}</div>) ||
        (warning && <span className="form-text text-muted">{warning}</span>))}
  </div>
)

const renderDateTimePicker = ({
  input,
  defaultValue,
  meta: { asyncValidating, touched, error }
}) => (
  <div>
    <DateTimePicker
      {...input}
      value={input.value !== "" ? new Date(input.value) : null}
      onChange={(event, value) => {
        input.onChange(event)
        console.log(event)
      }}
    />
    {touched && error && <div className="error">{error}</div>}
  </div>
)

const renderDropdownList = ({ input, defaultValue }) => (
  <DropdownList
    {...input}
    valueField="id"
    textField="name"
    data={tmpVenueList}
    value={input.value !== "" ? input.value : null}
  />
)

export class NewEvent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      event: {},
      editorState: EditorState.createEmpty(),
      editorStateVideoDetails: EditorState.createEmpty()
    }

    this.onChange = editorState => this.setState({ editorState })
    this.onChangeVideoDetails = editorStateVideoDetails =>
      this.setState({ editorStateVideoDetails })
    this.onFormChange = this.handleChange.bind(this)
  }

  componentWillMount() {
    fetch(`${process.env.REACT_APP_EF_API_URL}/venues/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(json => {
        //console.error('WE HAVE A RESULT: ' + JSON.stringify(json))
        //dispatch(fetchVenuesSuccess(json.venues))
        tmpVenueList = json.venues
        this.handleInitialize()
      })
      .catch(error => console.error(error))
  }

  handleInitialize() {
    const startDate = new Date()
    const event = {
      name: "",
      eventColor: "purple",
      startTime: startDate,
      endTime: startDate,
      details: "",
      bookingLink: "",
      cost: "",
      membersOnly: false,
      videoUrl: "",
      videoDetails: "",
      displayVideo: false,
      podcastUrl: "",
      displayPodcast: false,
      venue: tmpVenueList[0]
    }

    this.props.initialize(event)
    //this.setState(event)
    this.setState({
      event
    })
  }

  handleFormSubmit(formProps) {
    const editorDetails = this.state.editorState
      .getCurrentContent()
      .getPlainText()
    const editorVideoDetails = this.state.editorStateVideoDetails
      .getCurrentContent()
      .getPlainText()
    //console.log(editorDetails)
    //let blockMap = this.state.editorState.getCurrentContent().getBlockMap();
    //console.log('bm: ' +blockMap)
    //console.log(formProps)

    const eventProps = {
      name: formProps.name,
      details: editorDetails,
      startTime: formProps.startTime,
      endTime: formProps.endTime,
      bookingLink: formProps.bookingLink,
      videoUrl: formProps.videoUrl,
      videoDetails: editorVideoDetails,
      displayVideo: formProps.displayVideo,
      podcastUrl: formProps.podcastUrl,
      displayPodcast: formProps.displayPodcast,
      membersOnly: formProps.membersOnly,
      cost: formProps.cost,
      eventColor: formProps.eventColor,
      venue: formProps.venue._id
    }
    console.log(eventProps)
    this.props.saveEvent(eventProps)
  }

  handleChange(e) {
    // var currProp = e.target.name;
    // switch(currProp) {
    //   case 'startDate':
    //     console.log("StartDate!!")
    //     break;
    // }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Oops!</strong> {this.props.errorMessage}
        </div>
      )
    }
  }

  // _onBoldClick() {
  //   this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'BOLD'));
  // }

  render() {
    const { handleSubmit } = this.props

    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      // {tmpVenueList = this.props.venueList.venues}
      return (
        <div>
          <form
            onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}
            onChange={e => this.handleChange(e)}
          >
            <button action="submit" className="btn btn-success float-xs-right">
              Save
            </button>
            <blockquote className="blockquote">
              <h1>Create Event</h1>
            </blockquote>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="name"
                  type="text"
                  component={renderField}
                  label="Event Name"
                />
              </fieldset>
              <fieldset className="form-group">
                <label className="radio">
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="purple"
                  />
                  {" "}
                  <span className="block purple" />
                  {" "}General events & info
                </label>
                <br />
                <label>
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="teal"
                  />
                  {" "}
                  <span className="block teal" />
                  {" "}Focus dinners, supper club, onsite visits & open events
                </label>
                <br />
                <label>
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="yellow"
                  />
                  {" "}
                  <span className="block yellow" />
                  {" "}Annual conferences & award dinners
                </label>
                <br />
                <label>
                  <Field
                    name="eventColor"
                    component="input"
                    type="radio"
                    value="red"
                  />
                  {" "}
                  <span className="block red" />
                  {" "}Exchange programme
                </label>
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="startTime"
                  component={renderDateTimePicker}
                  hintText="Event Start Time"
                  autoOk={true}
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="endTime"
                  component={renderDateTimePicker}
                  hintText="Event End Time"
                  autoOk={true}
                />
              </fieldset>
              <fieldset className="form-group">
                {/* <button onClick={this._onBoldClick.bind(this)}>Bold</button> */}
                <label>Event Details</label>
                <Editor
                  editorState={this.state.editorState}
                  onChange={this.onChange}
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="bookingLink"
                  type="text"
                  component={renderField}
                  label="Event Booking Link"
                />
              </fieldset>
            </div>

            <div className="alert alert-success">Membership & Cost</div>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="cost"
                  type="text"
                  component={renderField}
                  label="Event Cost"
                />
              </fieldset>
              <fieldset className="form-group">
                <label>Members only?&nbsp;</label>
                <Field name="membersOnly" component="input" type="checkbox" />
              </fieldset>
            </div>

            <div className="alert alert-success">Event Video</div>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="videoUrl"
                  type="text"
                  component={renderField}
                  label="Event Video URL"
                />
              </fieldset>
              <fieldset className="form-group">
                <label className="form-control-label">Video Details</label>
                <Editor
                  editorState={this.state.editorStateVideoDetails}
                  onChange={this.onChangeVideoDetails}
                />
              </fieldset>
              <fieldset className="form-group">
                <label>Display video?&nbsp;</label>
                <Field name="displayVideo" component="input" type="checkbox" />
              </fieldset>
            </div>

            <div className="alert alert-success">Event Podcast</div>
            <div className="well">
              <fieldset classname="form-group">
                <Field
                  name="podcastUrl"
                  type="text"
                  component={renderField}
                  label="Event Podcast URL"
                />
              </fieldset>
              <fieldset classname="form-group">
                <label>Display podcast in mobile app?&nbsp;</label>
                <Field
                  name="displayPodcast"
                  id="displayPodcast"
                  component="input"
                  type="checkbox"
                />
              </fieldset>
            </div>

            <div className="alert alert-success">Venue</div>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="venue"
                  component={renderDropdownList}
                  label="Event Venue"
                />
              </fieldset>
            </div>

          </form>

        </div>
      )
    }
  }
}

function validate(formProps) {
  const errors = {}

  if (formProps.name === "") {
    errors.name = "You must enter an event name"
  }

  if (formProps.startTime === "") {
    errors.startTime = "Event must have a start time"
  }

  if (formProps.endTime === "") {
    errors.endTime = "Event must have an end time"
  }

  if (formProps.cost === "") {
    errors.cost = "Event must have a cost or be specified as free"
  }

  return errors
}

function warn(formProps) {
  const warnings = {}

  if (formProps.bookingLink === "") {
    warnings.bookingLink =
      "You can leave this blank but customers won't be able book this event"
  }
  return warnings
}

const form = reduxForm({
  form: "newevent",
  validate,
  warn
})

function mapStateToProps(state) {
  //console.log('state: ' +JSON.stringify(state))
  return {
    event: state.event
  }
}

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({
//     actions
//   }, dispatch)
// }

export default connect(mapStateToProps, actions)(form(NewEvent))



/** WEBPACK FOOTER **
 ** ./src/components/events/new.js
 **/